<template>
  <div>
    画像ビューアー
  </div>
</template>

<script>
export default {}
</script>

<style scoped></style>
